import Logo from './Logo';

// Styles imported in styles/index.scss to stop Vite moaning with the prerendered HTML

function Loading() {
  return (
    <div className="Loading">
      <Logo animate className="m-auto" />
    </div>
  );
}

export default Loading;
